import type { ModelMessage } from 'ai';
import { modelAdapterFor } from './model-input-adapter';

/**
 * @deprecated Use {@link modelAdapterFor}(modelId).finalizeMessages instead.
 */
export function finalizeModelMessages(
  messages: ModelMessage[],
  modelId: string
): ModelMessage[] {
  return modelAdapterFor(modelId).finalizeMessages(messages);
}
